import { Component, OnInit, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import * as XLSX from 'xlsx';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { DatePipe } from '@angular/common';
import { Organization } from '../../../common/model/Organization';
import { ReturnStoreFacade } from '../../../common/facade/ReturnStoreFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';


// for excel import
type AOA = any[][];

@Component({
  selector: 'app-return-store',
  templateUrl: './return-store.component.html',
  styleUrls: ['./return-store.component.css']
})
export class ReturnStoreComponent implements OnInit {
  titleReturnsToSupplier = res.ReturnsToSupplier;
  lblDownload = res.Download;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblStoreReturnReference = res.StoreReturnReference;
  lblRequestReference = res.RequestReference;
  lblOriginStore = res.OriginStore;
  lblReason = res.Reason;
  lblQuantity = res.Quantity;
  lblSendDate = res.SendDate;
  lblRequestReturn = res.RequestReturn;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;

  public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds());
  public txtMaxDate = this.getNowUTC();
  public txtStartDate = new Date();
  public txtEndDate = new Date();
  res = res;

  isSpanish = true;
  language = 0;

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  loading = false;
  messageLoader = '';
  // alert
  generalAlerts = [];

  // table
  rows = [];
  private _filteredData: any[] = [];


  // filters
  storeOriginId = -1;
  storesOrigin = [];

  // import excel
  excelData: AOA = [[], []];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName = 'SheetJS.xlsx';
  excelRows = [];

  // permissions
  hideStores = false;

  //ComboOrganizacion
  public TenantId = 0;
  public organizationList: Organization[] = [];
  public AvailableOrganizations: Organization[] = [];
  public selectedOrganization: Organization[] = [];
  public strOrganizationSelected: string;
  public strStores: string;
  public buttonEnable = false;
  private _strOrganizationSelected: any;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _router: Router,
    private _route: ActivatedRoute,
    private _returnStoreFacade: ReturnStoreFacade,
    private _facadeStore: StoreFacade,
    public datepipe: DatePipe,
    public strings: Strings
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1;
    }

    this.TenantId = this.strings.getTenant();

    this._route.queryParams.subscribe(params => {
      if (params['storeId'] !== undefined && params['startDate'] !== undefined && params['endDate'] !== undefined && params['selectedOrganizations'] !== undefined) {
        this._strOrganizationSelected = params['selectedOrganizations'];
        let organizationIds = this._strOrganizationSelected.split(',');
        let organizationSelectedAux = [];
        this.AvailableOrganizations.forEach(element => {
          organizationIds.forEach(id => {
            if (element.organizationId === id) {
              organizationSelectedAux.push(element)
            }
          })
        })
        this.strOrganizationSelected = this._strOrganizationSelected;
        this.selectedOrganization = organizationSelectedAux;
        this.txtStartDate = new Date(params['startDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
        this.txtEndDate = new Date(params['endDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
        this.txtMaxDate = new Date(params['endDate'].replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
        this.storeOriginId = Number(params['storeId']);
        this.getStores(true);

      } else {
        this.AvailableOrganizations = this.strings.getAvailableOrganizations();
        this.organizationList = this.AvailableOrganizations.filter(Orga => Orga.tenantId == this.TenantId);
      }
    });
  }

  initInfoFromDetail(storeId: number, startDate: string, endDate: string, selectedOrganizations: string) {
    this.storeOriginId = storeId;
    this.txtStartDate = new Date(startDate);
    this.txtMaxDate = new Date(endDate);
    this.txtEndDate = new Date(endDate);
    let organizationSelectedAux = [];
    this.AvailableOrganizations.forEach(element => {
      selectedOrganizations.split(',').forEach(id => {
        if (element.organizationId === id) {
          organizationSelectedAux.push(element)
        }
      })
    })
    this.selectedOrganization = organizationSelectedAux;
    //this.getReturnStoreByStoreDate();
  }

  private getReturnStore() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingReturnsToSupplier);
    this._returnStoreFacade.GetAllReturnStore().subscribe(
      response => {
        this.loading = false;
        this.rows = response.data.filter(x => x.storeName == this.strStores);
        this._filteredData = response.data;
        // this.storeOriginId = -1;
        //this.getStores();
        const navigation = this._route.queryParams.subscribe(params => {
          if (params['storeId'] !== undefined && Number(params['storeId']) > -1) {
            this.storeOriginId = params['storeId'];
            this.onStoreOriginChange();
          }
        });
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.ObtainingReturnsToSupplier), 'danger', 'general');
      }
    );
  }

  private getReturnStoreByStoreDate() {
    this.loading = true;
    if (new Date(this.txtStartDate) > new Date(this.txtEndDate)) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger', 'general');
      this.loading = false;
    }
    else {
      this.messageLoader = this.strings.GetText(res.ObtainingReturnsToSupplier);
      this._returnStoreFacade.GetReturnStoreByStoreDates(this.storeOriginId, this.datepipe.transform(this.txtStartDate, 'yyyyMMdd'),
        this.datepipe.transform(this.txtEndDate, 'yyyyMMdd')).subscribe(
          response => {
            this.loading = false;
            this.rows = response.data.filter(x => x.storeName == this.strStores);
            this._filteredData = response.data;
            // this.storeOriginId = -1;
            //this.getStores();

            this._route.queryParams.subscribe(params => {
              if (params['storeId'] !== undefined && Number(params['storeId']) > -1) {
                this.storeOriginId = params['storeId'];
                this.onStoreOriginChange();
              }
            });
          }, error => {
            this.loading = false;
            this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.ObtainingReturnsToSupplier), 'danger', 'general');
          }
        );
    }
  }

  private getStores(callInfo: boolean = false) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        this.storesOrigin = response.data.filter(st => this.strOrganizationSelected.includes(st.organizationId));
        if (callInfo) {
          this.getReturnStoreByStoreDate();
        }
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AletStoreListCouldNotBeObtained), 'danger', 'general');
      }
    );
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        const info = {
          [this.strings.GetText(res.StoreReturnReference)]: row.returnStoreId.toString(),
          [this.strings.GetText(res.OriginStore)]: row.storeName,
          [this.strings.GetText(res.Reason)]: row.comment,
          [this.strings.GetText(res.Quantity)]: row.sentQuantity,
          [this.strings.GetText(res.Cedis)]: row.cedis,
          [this.strings.GetText(res.SendDate)]:
            this.isSpanish ? this.datepipe.transform(row.shippingDate, 'dd/MM/yyyy') : this.datepipe.transform(row.shippingDate, 'MM/dd/yyyy')
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, this.strings.GetText(res.ReturnsToSupplier));
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger', 'general');
    }
  }

  // go toDetail
  onViewDetail(id) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'storeid': this.storeOriginId,
        'startDate': this.datepipe.transform(this.txtStartDate, 'yyyyMMdd'),
        'endDate': this.datepipe.transform(this.txtEndDate, 'yyyyMMdd'),
        'selectedOrganizations': this.strOrganizationSelected
      }
    };
    this._router.navigate(['return/return-store/detail/', id], navigationExtras);
  }

  // filter Transfer
  onStoreOriginChange() {
    if (this.storeOriginId == -1) {
      this.rows = this._filteredData;
      this.buttonEnable = false;
    } else {
      this.buttonEnable = true;

      this.strStores = this.storesOrigin.filter(it => { return it.storeId == Number.parseInt(this.storeOriginId.toString()) }
      ).pop().storeName;
      //this.rows = this._filteredData.filter(item => {
      //    return (item.storeName == stFilter);
      //});
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  // añadir alert
  addAlert(message: String, type: String, fileType: String) {
    this.generalAlerts = [];
    this.generalAlerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent, fileType: String): void {
    this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
  }

  onChangeOrganization(selectedOrganization: any[]) {
    this.rows = [];
    this.selectedOrganization = selectedOrganization;
    this.strOrganizationSelected = this.selectedOrganization.map(e => e.organizationId).join(',');
    this.getStores();
  }

  search() {
    if (this.dataValidated()) {
      this.getReturnStoreByStoreDate();
    }
  }

  dataValidated() {
    if (!(this.storeOriginId > -1)) {
      this.getMessageErrorDataValidation(res.SelectAStore);
      return false;
    } else {
      return true
    }
  }


  getMessageErrorDataValidation(message: any) {
    this.strings.GetText(message);
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  onChangeStartDate(value) {
    this.txtStartDate = value;
  }

  onChangeEndDate(value) {
    this.txtEndDate = value;
  }
}
